"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LogoTwitter = function Svg16LogoTwitter(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M9.032 18.9c6.037 0 9.34-4.925 9.34-9.196 0-.14 0-.279-.01-.418A6.621 6.621 0 0 0 20 7.613c-.6.262-1.235.433-1.885.509a3.253 3.253 0 0 0 1.443-1.788 6.642 6.642 0 0 1-2.085.785 3.302 3.302 0 0 0-1.862-.976 3.33 3.33 0 0 0-2.082.34 3.256 3.256 0 0 0-1.442 1.516 3.189 3.189 0 0 0-.208 2.067 9.434 9.434 0 0 1-3.747-.98A9.294 9.294 0 0 1 5.114 6.69a3.191 3.191 0 0 0-.36 2.355c.189.802.68 1.502 1.376 1.959a3.297 3.297 0 0 1-1.49-.404v.04c0 .747.263 1.47.743 2.047.48.578 1.148.974 1.89 1.122-.483.13-.99.148-1.482.055.21.642.619 1.204 1.168 1.606a3.32 3.32 0 0 0 1.9.639A6.653 6.653 0 0 1 4 17.449a9.4 9.4 0 0 0 5.032 1.448",
    fill: useDefaultColors ? '#55ACEE' : fill
  }));
};

Svg16LogoTwitter.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LogoTwitter;
exports.default = _default;